import { getOssToken } from '../security/tokenHelper';

export default (url, options, headers, onError) => {
  const header = {
    headers: new Headers({
      ...headers,
      accept: 'application/json, application/xml, text/plain, text/html, *.*',
      authorization: getOssToken(),
    }),
  };

  const fetchOptions = { ...header, ...options };

  const aFetch = async () => {
    const response = await fetch(url, fetchOptions);
    const data = await response.json();

    if (data) {
      const dataKeys = Object.keys(data);
      if (!dataKeys.includes('error')) {
        return data;
      }
      // error handle ?
    }

    return null;
  };

  return aFetch().catch(x => {
    if (onError && x.message && x.message.includes('fetch')) {
      onError();
    }
  });
};
